// extracted by mini-css-extract-plugin
export default {"thumb":"OlNQ6EYwtTn9B7CYTBuI"};